import { Component, OnInit } from '@angular/core';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { StatsService } from '../../../../shared/services/pubServices/stats.service';
import { IconversionsFilter, Page} from '../../../../shared/filters/filters';
import { SharedService } from 'src/app/shared/services/sharedServices/shared.service';
import { ToastrService } from 'ngx-toastr';
import { SignalrService } from 'src/app/shared/services/websecket/signalr.service';
import { browserRefresh } from '../../../../app.component';
import { Subscription } from 'rxjs'

@Component({
  selector: 'pub-conv-component',
  templateUrl: './conv-component.html',
  styleUrls: ['./conv-component.scss']
})

export class conversionsComponent implements OnInit {
  public browserRefresh: boolean;
  conversionActivated: Subscription;

  fromDate: any; // parametr dla pola na widoku
  toDate: any; // parametr dla pola na widoku
  DateMax: any;

  btnName: any;
  btnColor: any;
  btnOn: any = false;

  conversionsData: any;

  page = new Page();
  filter : IconversionsFilter = { pageNumber:1, pageSize:40 };
  offsetNumber: number;
  pageSizeDefinition = 40;

  dropdownListStatus : any[] = [];
  selectedItemsStatus : any[] = [];
  dropdownSettingsStatus: any = {};

  dropdownListCountry : any[] = [];
  countries: any;
  selectedItemsCountry : any[] = [];
  dropdownSettingsCountry: any = {};

  ColumnMode = ColumnMode;

  constructor(private statsService: StatsService,
              private sharedServices: SharedService,
              private toastrService: ToastrService,
              private signalrService: SignalrService) {
    this.DateMax = new Date().toISOString().split('T')[0];
    this.btnName = "Filter";
    this.btnColor = "btn-info";

    this.offsetNumber = 0;
    this.page.pageNumber = 1;
    this.page.size = this.pageSizeDefinition;
   }

   ngOnInit() {
    // aktywacja obserwatora
    this.conversionActivated= this.signalrService.newConversionActivated.subscribe((id)=>{
      if(id==1){
        this.setPage({ offset: 0 });
      }
    })

    // weryfikacja czy nastąpiło refreshe page (F5)
    this.browserRefresh = browserRefresh;
    if(this.browserRefresh)
    {
      this.signalrService.startConnection();
      this.signalrService.newConversionListener();
    }

    this.dropdownListStatus = [
      { item_id: 1, item_text: 'Pending' },
      { item_id: 3, item_text: 'Paid' },
      { item_id: 2, item_text: 'Reversed' }
    ];
    this.dropdownSettingsStatus = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    // country dropdownListStatus
    this.getCountries();
    this.dropdownSettingsCountry = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.setSelected();

    if(this.statsService.getFilter(14)){
      // filter is ON
      this.btnName = "Filter";
      this.btnColor = "btn-danger";
      this.btnOn = true;
    }

    this.setPage({ offset: this.statsService.getFilter(15) });
  }

  getCountries(): void {
    this.sharedServices.getAllCountries()
    .subscribe(
     data => {
       this.countries = data.data.countries;
     },
     error => {
       console.log(error);
     });
  }

  setPage(pageInfo){
    this.filter.pageNumber = pageInfo.offset+1;
    this.filter.pageSize = this.pageSizeDefinition;
    this.statsService.saveFilter(15, pageInfo.offset);

    this.statsService.getConversions(this.filter)
    .subscribe(
     data => {
      this.page.totalElements = data.totalRecords;
      this.page.totalPages = data.totalPages;
      this.page.pageNumber = data.pageNumber-1;
      this.conversionsData = data.data;
     },
     error => {
       console.log(error);
     });
  }

  setSelected(){
    this.selectedItemsStatus = this.statsService.getFilter(10);
    if(this.selectedItemsStatus==null)
      {
        this.selectedItemsStatus = [
        ];
        this.statsService.saveFilter(10, this.selectedItemsStatus);
      }

    this.selectedItemsCountry = this.statsService.getFilter(11);
      if(this.selectedItemsCountry==null)
      {
        this.selectedItemsCountry = [
        ];
        this.statsService.saveFilter(11, this.selectedItemsCountry);
      }

    this.fromDate = this.statsService.getFilter(12);
    this.toDate = this.statsService.getFilter(13);

    this.offsetNumber = 0;// rzeczywisty numer strony jest offsetNumber+1, 0 odpowiada pierwszej stronie
    this.setFilter();
  }

  setFilter(){
    // filtr Status
    delete this.filter.conversionStatuses;
    if(this.selectedItemsStatus.length>0)
      {
        // coś zostało wybrane lub coś jest ustawione
        this.filter.conversionStatuses= [];
        for(var i=0; i<this.selectedItemsStatus.length; i++)
          this.filter.conversionStatuses[i] = this.selectedItemsStatus[i].item_id;
        this.statsService.saveFilter(10, this.selectedItemsStatus);
      }

    // filter Countries
    delete this.filter.visitorCountries;
    if(this.selectedItemsCountry.length>0)
      {
        // coś zostało wybrane lub coś jest ustawione
        this.filter.visitorCountries = [];
        for(var i=0; i<this.selectedItemsCountry.length; i++)
          this.filter.visitorCountries[i] = this.selectedItemsCountry[i].id;
        this.statsService.saveFilter(11, this.selectedItemsCountry);
      }

    delete this.filter.startDate;
    if(this.fromDate!=null && this.fromDate!="")
      {
        var startDate: Date;
        startDate = new Date(this.fromDate);
        var isoDateStart = new Date(startDate.getTime() + startDate.getTimezoneOffset() * 60000).toISOString();
        this.filter.startDate = isoDateStart;
        this.statsService.saveFilter(12, this.fromDate);
      }

    delete this.filter.endDate;
    if(this.toDate!=null && this.toDate!="")
    {
      var endDate: Date;
      endDate = new Date(this.toDate);
      endDate.setHours(endDate.getHours() + 24);
      var isoDateEnd = new Date(endDate.getTime() + endDate.getTimezoneOffset() * 60000).toISOString();
      this.filter.endDate = isoDateEnd;
      this.statsService.saveFilter(13, this.toDate);
    }
}

  onFilter(){
    // wartość "" jest ustawiana gdy w dropdown liście daty zostanie użyta funkcja 'wyczyść'
    if(this.fromDate=="")
    {
      this.fromDate=null;
      this.statsService.saveFilter(12, this.fromDate);
    }
    if(this.toDate=="")
    {
      this.toDate=null;
      this.statsService.saveFilter(13, this.toDate);
    }

    if(this.toDate<this.fromDate)
      this.toastrService.error('End date can not be before start date, please correct.', 'Error !');
    else
    {
      // filter is ON
      this.btnName = "Filter";
      this.btnColor = "btn-danger";
      this.btnOn = true;
      this.statsService.saveFilter(14, this.btnOn);

      this.setFilter();
      this.setPage({ offset: 0 });
    }
  }

  onClear(){
    // filter is OFF and default parameters are used
    this.btnName = "Filter";
    this.btnColor = "btn-info";
    this.btnOn = false;
    this.statsService.saveFilter(14, this.btnOn);

    this.selectedItemsStatus = [
    ];
    this.statsService.saveFilter(10, this.selectedItemsStatus);

    this.selectedItemsCountry = [
    ];
    this.statsService.saveFilter(11, this.selectedItemsCountry);

    this.fromDate = null;
    this.statsService.saveFilter(12, this.fromDate);
    this.toDate = null;
    this.statsService.saveFilter(13, this.toDate);

    delete this.filter.conversionStatuses;
    delete this.filter.visitorCountries;
    delete this.filter.startDate;
    delete this.filter.endDate;
    this.filter.pageNumber = 1;
    this.filter.pageSize = this.pageSizeDefinition;

    this.setFilter();
    this.setPage({ offset: 0 });
  }

  onItemSelect(item: any) {}
  onSelectAll(items: any) {}
  onItemSelectCountry(item: any) {}
  onSelectAllCountry(items: any) {}
}
